// Modules
import { FormattedMessage } from 'react-intl';
import Link from 'next/link';
// Utils
import api from '~/services/api';
import actions from '~/services/log-actions';
// Styles
import styles from './category-posts-header.module.scss';

const CategoryPostsHeader = ({ title, hasMore = true, slug }) => {
  const handleClickOnTitle = () => {
    api.sendLog(actions.ROW_TITLE_CLICK, { title });
  };

  const handleClickOnShowMore = () => {
    api.sendLog(actions.ROW_SHOW_MORE_CLICK, { title });
  };

  return (
    <div className={`${styles['wrapper']} container`}>
      {title && (
        <div className={styles['wrapper__title']}>
          <Link href={slug} title={title} onClick={handleClickOnTitle}>
            {title}
          </Link>
        </div>
      )}

      {hasMore && (
        <Link className={styles['wrapper__view-all']} href={slug} onClick={handleClickOnShowMore}>
          <FormattedMessage id="apron.plus.view_all" />
        </Link>
      )}
    </div>
  );
};

export default CategoryPostsHeader;
